// --------------------------------
// --------------------------------
$(document).ready(function () {
    $(".show_hide").on("click", function () {
        var txt = $(".read-more").is(':visible') ? 'Read More' : 'Read Less';
        $(".show_hide").text(txt);
        $(this).next('.read-more').slideToggle(200);
    });

    $(".show_hide_bottom").on("click", function () {
        var txt = $(".read-more-bottom").is(':visible') ? 'Read More' : 'Read Less';
        $(".show_hide_bottom").text(txt);
        $(this).next('.read-more-bottom').slideToggle(200);
    });
});
// --------------------------------
// --------------------------------



// --------------------------------
// --------------------------------
window.addEventListener("pageshow", function (event) {
  // DISABLED: This was causing infinite reloads on product pages
  // The pageshow event fires on every page load, including reloads
  // We should NOT reload on product pages at all
  
  var currentPath = window.location.pathname;
  var isProductPage = currentPath.indexOf('/products/') !== -1;
  
  // NEVER reload on product pages - this was causing infinite loops
  if (isProductPage) {
    // console.log('[Custom] pageshow event on product page - reload disabled to prevent loops');
    return;
  }
  
  // For non-product pages, only reload on back/forward navigation (not on initial load or refresh)
  var historyTraversal = false;
  
  // Check for persisted state (bfcache restore)
  if (event.persisted) {
    historyTraversal = true;
  }
  
  // Check for back/forward navigation using modern API
  // navigation.type: 0 = navigate, 1 = reload, 2 = back/forward
  if (typeof window.performance !== "undefined" && window.performance.navigation) {
    // Only reload on back/forward navigation (type === 2)
    if (window.performance.navigation.type === 2) {
      historyTraversal = true;
    }
  }
  
  // Only reload if it's actually a back/forward navigation
  if (historyTraversal) {
    // Use a flag to prevent multiple reloads
    if (!sessionStorage.getItem('pageReloaded')) {
      sessionStorage.setItem('pageReloaded', 'true');
      setTimeout(function() {
        sessionStorage.removeItem('pageReloaded');
      }, 1000);
      
      // console.log('[Custom] Reloading page after back/forward navigation');
      window.location.reload();
    }
  }
});
$(function () {
  $(".button-atc").click(function () {
    //use a class, since your ID gets mangled
    $(this).addClass("button--loading"); //add the class to the clicked element
  });
});
// --------------------------------
// --------------------------------

